import React, { useState, useEffect } from 'react';
import './PreWedding.css';

const PreWedding = () => {
  const weddingDate = new Date('2025-12-15T00:00:00');
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const difference = weddingDate - now;
      const time = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
      setTimeLeft(time);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const galleryImages = [
    'https://tse1.mm.bing.net/th/id/OIP.fDvog2Ne1TwpuNwDL7nBDgHaEK?r=0&rs=1&pid=ImgDetMain&o=7&rm=3',
    'https://tse3.mm.bing.net/th/id/OIP.qv3o7Oqf41QgI5UcDfA0mgHaEf?r=0&rs=1&pid=ImgDetMain&o=7&rm=3.',
    'https://i0.wp.com/wevaphotography.com/wp-content/uploads/2019/05/traditional-prewedding-athirapally-waterfalls15.jpg?fit=4798%2C3199&ssl=1',
    'https://i.pinimg.com/originals/55/bc/07/55bc07cde7756d4c11adb134d37baf66.jpg',
    'https://th.bing.com/th/id/R.6fc748c8c33b41cf0872bc95871e1743?rik=WTy%2fk6Amqkxayw&riu=http%3a%2f%2fwww.partner.lk%2fphotos%2f1391845_688547811172657_793190778_n.jpg&ehk=AXiDs8KTXk9dUr8MAZvojWBAP4YQ5WViu1xT3t7fL28%3d&risl=&pid=ImgRaw&r=0',
    'https://tse2.mm.bing.net/th/id/OIP.jkYotXNbZpRLz2_FbN0b_gHaE7?r=0&w=1024&h=682&rs=1&pid=ImgDetMain&o=7&rm=3',
    'https://i.pinimg.com/736x/d6/5a/1a/d65a1a93043ec43b574b055df139d256.jpg',
    'https://weddingvyapar.com/wp-content/uploads/2024/08/wayanad-min.png',
  ];

  return (
    <div className="pre-wedding-page">
      {/* Hero Banner */}
      <div className="hero">
        <div className="overlay">
          <h1>Raj & Meera</h1>
          <p className="tagline">Two souls, one journey</p>
          <p className="date">Celebrating Love Before the Big Day</p>
        </div>
      </div>

      {/* Love Story */}
      <section className="love-story">
        <h2>Our Love Story</h2>
        <div className="timeline">
          <div className="event">
            <img src="https://images.unsplash.com/photo-1517487881594-2787fef5ebf7" alt="How we met" />
            <div>
              <h3>How We Met</h3>
              <p>Met during college fest in 2018.</p>
            </div>
          </div>
          <div className="event">
            <img src="https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e" alt="First Date" />
            <div>
              <h3>First Date</h3>
              <p>Coffee and laughter at our favorite café.</p>
            </div>
          </div>
          <div className="event">
            <img src="https://www.bespoke-experiences.com/wp-content/uploads/2021/08/288.jpeg" alt="Engagement" />
            <div>
              <h3>Engaged</h3>
              <p>He proposed on a beach in Goa. 2024.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="gallery">
        <h2>Pre-Wedding Gallery</h2>
        <div className="gallery-grid">
          {galleryImages.map((url, i) => (
            <div className="gallery-item" key={i}>
              <img src={url + '?w=400&h=400&fit=crop'} alt={`Gallery ${i + 1}`} />
            </div>
          ))}
        </div>
      </section>

      {/* Video */}
<div className="video-section">
  <h1>Pre-Wedding Video</h1>
  <div className="video-wrapper">
    <iframe
      src="https://www.youtube.com/embed/S_C3T2XCLlo"
      frameBorder="0"
      allow="autoplay; encrypted-media"
      allowFullScreen
      title="Pre-Wedding Video"
    ></iframe>
  </div>
</div>


      {/* Countdown */}
      <div className="countdown">
        <h1>Countdown to Wedding</h1>
        <div className="timer">
          <div><span>{timeLeft.days}</span><p>Days</p></div>
          <div><span>{timeLeft.hours}</span><p>Hours</p></div>
          <div><span>{timeLeft.minutes}</span><p>Minutes</p></div>
          <div><span>{timeLeft.seconds}</span><p>Seconds</p></div>
        </div>
      </div>
    </div>
  );
};

export default PreWedding;
